import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WSharingOptionsHorizontalCCD: IClientComponentDefinition = {
  name: 'WSharingOptionsHorizontal',
  load: () =>
    import(/* webpackChunkName: 'WSharingOptionsHorizontal' */ './sharing-options-horizontal'),
}
